import React from "react";
import { Routes } from './../Core/Constants';
import { Storage } from './../Core/Storage';
import { CartProvider } from './../Providers/CartProvider';
import { AppStore } from './../Core/AppStore';
import CartProducts from './../Components/CartProducts.jsx';

export default class CartForm extends React.Component {

    state = {
        redirectToCheckout: false,

    }
    componentDidMount = () => {

        AppStore.on("Cart.AfterUpdate", () => {
            if (this.state.editing > 0) {
                this.setState({ editing: 0 });
            }
            else {
                this.forceUpdate();
            }
        });
        CartProvider.validateCart((cachedCart) => {
            window.gtm.loadCart(cachedCart);
        });
    }

    handleChangeCount = (e, cartItem) => {

        var newCount = parseInt(e.target.value);
        if (!isNaN(newCount)) {
            e.preventDefault();
            const quantitytoadd = parseInt(cartItem.product.quantityToAdd);
            if (quantitytoadd > 1) {
                if (this.checkItemCountValidity(cartItem, newCount)) {
                    CartProvider.changeItem(cartItem, newCount);
                }
            }
            else {
                CartProvider.changeItem(cartItem, newCount);
            }

        }
        else {
            if (e.target.value != '') {
                e.preventDefault();
            }
            else {
                this.setState({ editing: cartItem.product.id })
            }
        }
    }

    checkItemCountValidity = (cartItem, newCount) => {
        const T = window.Texts.cart;
        const quantitytoadd = parseInt(cartItem.product.quantityToAdd);
        let rest = newCount % quantitytoadd;
        if (rest) {
            newCount = newCount + quantitytoadd - rest;
            const msg = T.quantityToAddWarning.replace("{name}", cartItem.product.name)
                .replace("{quantitytoadd}", quantitytoadd)
                .replace("{newcount}", newCount);
            if (confirm(msg)) {
                CartProvider.changeItem(cartItem, newCount);
            }
            return false;
        }
        return true;
    }

    handleBlur = (e, cartItem) => {
        var newCount = parseInt(e.target.value);
        if (!isNaN(newCount)) {
            this.checkItemCountValidity(cartItem, newCount);
        }

        if (this.state.editing > 0) {
            this.setState({ editing: 0 });
        }
    }

    removeItem = (e, cartItem) => {
        e.preventDefault();
        CartProvider.removeItem(cartItem);
    }

    removeCoupon = (e) => {
        e.preventDefault();
        CartProvider.removeCoupon();
    }


    handleToCheckout = (e) => {
        e.preventDefault();
        let isValid = true;
        CartProvider.validateCart((cachedCart) => {
            cachedCart.cartedProducts.map((item) => {
                if (!this.checkItemCountValidity(item))
                    isValid = false;
            });

            if (isValid)
                window.location = Routes.Checkout + "?ts=" + Math.floor(Math.random() * 1000);            
        });
    }

    render() {
        var T = window.Texts.cart;

        let cart = Storage.instance().cachedCart;
        let rawCart = Storage.instance().cart;
        if (!rawCart || !rawCart.cartedProducts || rawCart.cartedProducts.length == 0)
            return (
                <div className="page-cart">
                    <div className="cover">
                        <div className="page-headline">
                            <h1>{T.yourCart}</h1>
                        </div>
                        <div id="CartList"><p>{T.emptyCart}</p></div>
                        <CartProducts />
                    </div>
                </div>);


        if (!cart)
            return <div>{T.loading}</div>;

        console.log('CartForm render', cart);
        return (
            <form>
                <div>
                    <div className="page-cart">
                        <div className="cover">
                            <div className="page-headline">
                                <h1>{T.yourCart}</h1>
                            </div>
                            <div id="CartList">
                                <table className="table">
                                    <tbody>
                                        {cart.cartedProducts.map((item) => {
                                            return (<tr key={item.product.id}>
                                                <td className="thumb">
                                                    <div className="inner">
                                                        <img src={item.product.thumb ? item.product.thumb.url : null} />
                                                    </div>
                                                </td>
                                                <td className="name">
                                                    <div className="inner">
                                                        <a className="no-line underline" href={item.product.url} title={item.product.name}><u>{item.product.name}</u></a>
                                                        <span className="amount-in-store green"><b dangerouslySetInnerHTML={{ __html: item.product.displayAvailability }}></b></span>
                                                        <a className="no-line remove-item" href="#" onClick={(e) => this.removeItem(e, item)}></a>
                                                    </div>
                                                </td>
                                                <td className="count">
                                                    <input type="number" step={item.product.quantityToAdd > 1 ? item.product.quantityToAdd : 1} className="form-control" value={(this.state.editing == item.product.id) ? '' : item.count} onFocus={(e) => e.target.select()} onBlur={(e) => this.handleBlur(e, item)} onChange={(e) => this.handleChangeCount(e, item)} />
                                                </td>
                                                <td className="price">
                                                    <div className="inner">
                                                        <span>{item.priceTable.displayTotalPriceInclVat}</span>
                                                        <small>{item.priceTable.displayTotalPriceExclVat} {T.withoutTax}</small>
                                                    </div>
                                                </td>
                                                <td className="remove">
                                                    <a className="no-line remove-item" href="#" onClick={(e) => this.removeItem(e, item)}></a>
                                                </td>
                                            </tr>);
                                        })}
                                        {cart.coupon ?
                                            <tr key="coupon">
                                                <td className="thumb">
                                                    <div className="inner">
                                                        <img src="content/img/barcode48.png" />
                                                    </div>
                                                </td>
                                                <td className="name">
                                                    <div className="inner">
                                                        <b>{cart.coupon.name}</b> - {cart.coupon.code}
                                                        <span className="amount-in-store green"></span>
                                                        <a className="no-line remove-item" href="#" onClick={(e) => this.removeCoupon(e)}></a>
                                                    </div>
                                                </td>

                                                {cart.displayRemainingPriceForApplyCoupon ? 
                                                    <td className="price" colSpan={2}>
                                                        <div className="inner">
                                                            <span style={{ color: 'red' }}>{T.buyMoreFor} {cart.displayRemainingPriceForApplyCoupon}</span>
                                                            <small style={{ color: 'red' }}>{T.minimumOrder} {cart.displayMinHomeApplyCouponThreshold}</small>
                                                        </div>
                                                    </td>
                                                    :
                                                    <>
                                                        <td className="count">
                                                        </td>
                                                        <td className="price">
                                                        <div className="inner">
                                                            <span style={{ color: 'green' }}>-{cart.coupon?.priceTable?.displayTotalPriceInclVat}</span>
                                                            <small style={{ color: 'green' }}>-{cart.coupon?.priceTable?.displayTotalPriceExclVat} {T.withoutTax}</small>
                                                        </div>
                                                        </td>
                                                    </>}
                                                <td className="remove">
                                                    <a className="no-line remove-item" href="#" onClick={(e) => this.removeCoupon(e)}></a>
                                                </td>
                                            </tr> : null}
                                    </tbody>
                                </table>
                                <div className="cart_footer">
                                    <div className="cart-summary">
                                        <ul>
                                            <li className="call2action">
                                                <div className="free-delivery">
                                       
                                                        {(cart.remainingPriceForFreeShipping && cart.remainingPriceForFreeShipping > 0) ?
                                                        <>
                                                            <h4>{T.freeShipping} {cart.displayMinHomeFreeShippingThreshold}</h4>
                                                            <p>{T.freeShippingAt.replace("{0}", cart.displayRemainingPriceForFreeShipping)}</p>
                                                        </> : null}
                                                    <p>{T.weight} {cart.totalWeight} Kg</p>
                                                </div>
                                            </li>
                                            <li className="price-button">
                                                <div className="price">
                                                    <h4>{cart.priceTable.displayTotalPriceInclVat}  {T.withTax} </h4>
                                                    <p>{cart.priceTable.displayTotalPriceExclVat}  {T.withoutTax}</p>
                                                </div>
                                                <button className="tocheckoutbtn btn btn60 iconed icon-continue" onClick={(e) => this.handleToCheckout(e)}>
                                                    <span>{T.toCheckout}</span>
                                                </button>
                                                <a className="continue" href="/">{T.continueShopping}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <CartProducts />
                        </div>
                    </div>
                </div>
            </form>
        );
    };
}